module.exports = __webpack_public_path__ + "media/images/icon/default/company-be0396fc4f9b3827e20908a7aa381fb7.png";